<template>
  <div>
    <el-config-provider :size="'default'" :locale="zhCn">
      <slot />
    </el-config-provider>
  </div>
</template>

<script setup>
import zhCn from 'element-plus/es/locale/lang/zh-cn'
</script>
